import { Invitation, Role, } from "myfitworld-model";
import { firestore } from "../../../firebase"
import safeInvoke from "../../../utils/safeInvoke";
import { updateInvitedUser } from "src/api/usersApi";


export const fetchOrganizationInvitations = async ({
  userId,
  organizationId,
  roles,
  role,
  isWhiteLabel
}: {
  userId:string; 
  organizationId: string;
  roles: Role[];
  role: Role|undefined;
  isWhiteLabel: boolean
}) => {
  let invitations: Invitation[] = [];
  try {
    if(role){
        const invitationDocs = await getInvitationDocs(organizationId, userId, roles, role);
        invitationDocs.docs.map(doc => invitations.push({
            id: doc.id,
            ...doc.data(),
            createdAt: safeInvoke('toDate')(doc.data().createdAt)
            } as Invitation));
    }

    return invitations;
  } catch (error) {
    throw error;
  }
};

const getInvitationDocs = async (organizationId: string, userId: string, roles: Role[], role: Role) => {
    try{
        let collectionRef = firestore.collection('invitations')
        let invitationRef = (organizationId ?
            collectionRef.where('organization', '==', organizationId) :
            collectionRef
        ).where('role', 'in', roles).where('acceptedOn', '==', null);

        if (role === Role.Trainer || role === undefined) {
            invitationRef = invitationRef.where('invitedBy', '==', userId || '');
        }

        const invitationDocs = await invitationRef.orderBy('createdAt').get();

        return invitationDocs;
    } catch (error) {
        throw error;
    }
}

export const renewInvitation = async (id: string, email: string, organizationId: string, userId: string) => {
  const invitationDoc = firestore.collection("invitations").doc(id);
  await invitationDoc.update({
    acceptedOn: null,
    rejected: false,
  });

  if (userId !== "") {
    // If userId is provided, update the specific user document
    const userDoc = firestore.collection("users").doc(userId);
    await userDoc.update({
      hasInvitation: true,
    });
  } else {
    // If userId is empty, find users by email. Check added because of previous bugs. 
    const userQuerySnapshot = await firestore.collection("users").where("email", "==", email).get();
    
    if (!userQuerySnapshot.empty) {
      const batch = firestore.batch();
      userQuerySnapshot.forEach((doc) => {
        batch.update(doc.ref, { hasInvitation: true });
      });
      await batch.commit(); // Commit batch update
    }
  }

  // await updateInvitedUser(email, wlOrgId);
};
